import React from 'react';
import Container from '../../Components/Container';

function RouteAbout() {
  return (
    <Container>
      <h1>
        About
      </h1>
    </Container>
  );
}

export default RouteAbout;



// WEBPACK FOOTER //
// ./src/Routes/RouteAbout/index.jsx